import styled from 'styled-components';
import { border } from 'styled-system';

import { Box } from '@hivebrite/design-system/Box';

export default styled(Box)
  .withConfig({
    shouldForwardProp: (prop) => !['coverPicture', 'isHovered'].includes(prop),
  })
  .attrs(() => ({
    height: '100%',
    width: '100%',
  }))`
  background-image: url('${({ coverPicture }) => coverPicture}');
  background-position: top center;
  background-repeat: no-repeat;
  background-size: cover;
  ${border}
`;
